<template>
  <div>
    <h3>
      <label :for="name">{{ title }}</label>
    </h3>
    <slot>
      <base-input v-bind="$attrs" @input="$emit('input', $event)" :id="name" />
    </slot>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      reqired: true,
    },
    name: {
      type: String,
      reqired: true,
    },
  },
};
</script>
